import { render, staticRenderFns } from "./InputCalcMatch.vue?vue&type=template&id=2f82e576&scoped=true&"
import script from "./InputCalcMatch.vue?vue&type=script&lang=js&"
export * from "./InputCalcMatch.vue?vue&type=script&lang=js&"
import style0 from "./InputCalcMatch.vue?vue&type=style&index=0&id=2f82e576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82e576",
  null
  
)

export default component.exports